import config from "@/config"
const base_url = window.config.env.request.url.base; // production
// 配置编译环境和线上环境之间的切换
let baseUrl = base_url; //http://192.168.0.139:8099   http://192.168.0.142:2828
// let baseUrl = base_url; //http://192.168.0.139:8099   http://192.168.0.142:2828
let flowableUrl = "http://localhost:2828"; //net工作流模块请求地址 java不需要
let loginUrl = "http://114.116.210.204:7410" //在线登录界面
let SSOUrl = []//["http://192.168.0.139:7755"] //需要单点登录的域名
let BI_URL = "http://114.116.210.204:2424";
let previewUrl = 'http://114.116.210.204:8012/onlinePreview?url='; // 文件在线 预览页面
let iconfontVersion = ['567566_pwc3oottzol'];
let iconfontUrl = ``;
let codeUrl = `${baseUrl}/code`
let KeycloakUrl = "http://192.168.0.221:12829/auth/" //keycloak请求地址
// const env = process.env;
const env = {
  NODE_ENV: import.meta.env.MODE === 'development' ? 'development':'production'
}
if (env.NODE_ENV == 'development') {
  baseUrl = import.meta.env.VUE_APP_API_BASEURL; // 开发环境地址
  flowableUrl = "http://192.168.110.104:2828";//net工作流模块请求地址
} else if (env.NODE_ENV == 'production') {
  loginUrl = "http://114.116.210.204:7410" //在线登录界面
  flowableUrl = "http://localhost:2828";//net工作流模块请求地址 java不需要
  baseUrl = window.config.env.request.url.base; //生产环境地址
  SSOUrl = ["http://114.116.210.204:2424"]// //需要单点登录的域名
  BI_URL = "http://114.116.210.204:2424" //BI项目部署地址
  previewUrl = 'http://114.116.210.204:8012/onlinePreview?url='; // 文件在线 预览页面
} else if (env.NODE_ENV == 'test') {
  baseUrl = `http://119.3.78.210:8282`; //测试环境地址
  loginUrl = "http://119.3.78.210:7410" //在线登录界面
  flowableUrl = "http://localhost:8282";//net工作流模块请求地址 java不需要
}
export {
  baseUrl,
  iconfontUrl,
  iconfontVersion,
  codeUrl,
  env,
  loginUrl,
  flowableUrl,
  SSOUrl,
  BI_URL,
  previewUrl,
  KeycloakUrl
}
